// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"2f6f0298","879":"fba5fe0f"}[chunkId] + ".chunk.js";
};